
  import createMeisterIcons from '../src/createMeisterIcons';

  const Beaker = createMeisterIcons("beaker", [["path",{"fill":"currentColor","d":"M10.7 3.7a.36.36 0 0 0-.35.35v4.508l-.471.188c-2.234.894-3.829 3.03-3.829 5.604a5.95 5.95 0 0 0 11.9 0c0-2.586-1.603-4.798-3.895-5.591l-.505-.175V4.05a.36.36 0 0 0-.35-.35zm-1.85.35A1.86 1.86 0 0 1 10.7 2.2h2.5a1.86 1.86 0 0 1 1.85 1.85v3.488c2.632 1.14 4.4 3.788 4.4 6.812a7.45 7.45 0 0 1-14.9 0c0-3.04 1.78-5.58 4.3-6.79z","key":"161f64d74e80eb13ac0b1119e9d0c660a6370d77","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Beaker
  